import React, { useState } from "react";
import "./Dashboard.css";

const Dashboard = () => {
  const [formData, setFormData] = useState({
    name: "",
    title: "",
    profileImage: "",
    bio: "",
    skills: "",
    email: "",
    projects: [],
  });

  const [project, setProject] = useState({
    title: "",
    description: "",
    link: "",
    image: "",
  });

  // form data handle
  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "profileImage") {
      const file = files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = () => {
          setFormData({ ...formData, profileImage: reader.result });
        };
        reader.readAsDataURL(file);
      }
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  // project data handle
  const handleProjectChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "image") {
      const file = files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = () => {
          setProject({ ...project, image: reader.result });
        };
        reader.readAsDataURL(file);
      }
    } else {
      setProject({ ...project, [name]: value });
    }
  };

  const addProject = () => {
    setFormData({ ...formData, projects: [...formData.projects, project] });
    setProject({ title: "", description: "", link: "", image: "" });
  };

  return (
    <div className="dashboard">
      {/* Left Form */}
      <div className="form-section">
        <h2>Portfolio Builder</h2>
        <input
          type="text"
          name="name"
          placeholder="Full Name"
          value={formData.name}
          onChange={handleChange}
        />
        <input
          type="text"
          name="title"
          placeholder="Tagline / Role"
          value={formData.title}
          onChange={handleChange}
        />
        <label>Profile Image</label>
        <input type="file" name="profileImage" onChange={handleChange} />

        <textarea
          name="bio"
          placeholder="Short Bio"
          value={formData.bio}
          onChange={handleChange}
        />

        <input
          type="text"
          name="skills"
          placeholder="Skills (comma separated)"
          value={formData.skills}
          onChange={handleChange}
        />

        <h3>Projects</h3>
        <input
          type="text"
          name="title"
          placeholder="Project Title"
          value={project.title}
          onChange={handleProjectChange}
        />
        <textarea
          name="description"
          placeholder="Project Description"
          value={project.description}
          onChange={handleProjectChange}
        />
        <input
          type="text"
          name="link"
          placeholder="Project Link"
          value={project.link}
          onChange={handleProjectChange}
        />
        <input type="file" name="image" onChange={handleProjectChange} />
        <button onClick={addProject}>+ Add Project</button>

        <input
          type="email"
          name="email"
          placeholder="Contact Email"
          value={formData.email}
          onChange={handleChange}
        />
      </div>

      {/* Right Preview */}
      <div className="preview-section">
        <div className="header">
          <h2>{formData.name || "Your Name"}</h2>
          <h4>{formData.title || "Your Title"}</h4>
        </div>

        {/* About Section */}
        <h3>About</h3>
        <div className="bio-section">
          {formData.profileImage && (
            <img src={formData.profileImage} alt="Profile" />
          )}
          <p>{formData.bio || "A short bio about yourself..."}</p>
        </div>

        {/* Skills */}
        <h3>Skills</h3>
        <div className="skills-tags">
          {formData.skills
            ? formData.skills.split(",").map((skill, i) => (
                <span key={i} className="skill-tag">
                  {skill.trim()}
                </span>
              ))
            : "Your skills will appear here"}
        </div>

        {/* Projects */}
        <h3>Projects</h3>
        <div className="project-grid">
          {formData.projects.length > 0 ? (
            formData.projects.map((proj, i) => (
              <div key={i} className="project-card">
                {proj.image && <img src={proj.image} alt={proj.title} />}
                <h4>{proj.title}</h4>
                <p>{proj.description}</p>
                {proj.link && (
                  <a href={proj.link} target="_blank" rel="noreferrer">
                    🔗 View Project
                  </a>
                )}
              </div>
            ))
          ) : (
            <p>No projects added yet</p>
          )}
        </div>

        {/* Contact */}
        <h3>Contact</h3>
        <p>{formData.email || "your@email.com"}</p>
      </div>
    </div>
  );
};

export default Dashboard;
